import { request } from "./HttpService";
import { properties } from "../properties";
import { ftAccessToken, ftRefreshToken } from "../constants/Constants";
import { refreshToken } from "./AuthService";

export function fetchOutreachCandidates() {
    return request("GET", "/admin/outreach");
}

export function ingestOutreachCandidates(startDate, endDate) {
    return request("POST", "/admin/outreach/ingest", { startDate, endDate });
}

export function refreshOutreachLinks() {
    return request("POST", "/admin/outreach/refresh-links");
}

export function deleteOutreachCandidate(id) {
    return request("DELETE", "/admin/outreach/" + id);
}

export function getOutreachIngestStatus() {
    return request("GET", "/admin/outreach/ingest/status");
}

export function downloadOutreachCsv(startDate, endDate, dateField, includeTitle = false, firstCall = true) {
    return new Promise((resolve, reject) => {
        const accessToken = localStorage.getItem(ftAccessToken)?.replaceAll('"', '');
        const params = new URLSearchParams();
        if (startDate) params.append("startDate", startDate);
        if (endDate) params.append("endDate", endDate);
        if (dateField) params.append("dateField", dateField);
        if (includeTitle) params.append("includeTitle", "true");
        const query = params.toString();
        const url = properties.host + "/admin/outreach/export" + (query ? "?" + query : "");
        const xhttp = new XMLHttpRequest();
        xhttp.open("GET", url, true);
        xhttp.responseType = "blob";
        xhttp.setRequestHeader("Authorization", "Bearer " + accessToken);
        xhttp.onreadystatechange = function () {
            if (this.readyState !== 4) return;
            if (this.status === 200) {
                resolve({
                    blob: xhttp.response,
                    disposition: xhttp.getResponseHeader("Content-Disposition"),
                });
            } else if ((this.status === 401 || this.status === 403) && firstCall) {
                refreshToken()
                    .then(newAccessToken => {
                        localStorage.setItem(ftAccessToken, JSON.stringify(newAccessToken));
                        return downloadOutreachCsv(startDate, endDate, dateField, includeTitle, false).then(resolve).catch(reject);
                    })
                    .catch(() => {
                        localStorage.removeItem(ftAccessToken);
                        localStorage.removeItem(ftRefreshToken);
                        reject(new Error("auth"));
                    });
            } else {
                reject(new Error("Download failed"));
            }
        };
        xhttp.send();
    });
}
